import { Tag } from '@delmonicos/shared-design-system-react/src/components/tag/tag';
import {
  Text,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { CellContext } from '@tanstack/react-table';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { mapStateToGenericTransactionState } from '@app/feature/charge-point/helper/transaction-state.helper';

export interface TransactionListStateCellProps
  extends CellContext<TransactionModel, TransactionModel['state']> {}

export const TransactionListStateCell = (
  props: TransactionListStateCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;
  const { t } = useTranslation();

  // RENDER ////////////////////////////////////////////////////////////////////

  const { color, name } = mapStateToGenericTransactionState(getValue());

  return (
    <Tag className={classNames(color)}>
      <Text italic fontSize={TextFontSize.Small}>
        {t(`delmonicos-shared-sdk.enums-transaction-state.${name}`)}
      </Text>
    </Tag>
  );
};
